/**
 * home 首页下拉/弹出面板统一的表层样式：圆角、背景色、背景模糊、动效。
 *
 * 以 DurationGridSelect（时长下拉）现有写法为基准：动效 class 列表原样照抄（含
 * fade/zoom/slide 与 animate-in/out），与 Select 基础样式里的 scaleYIn/scaleYOut
 * 共存也是这份基准本来的写法，不额外用 !important 改变其既有覆盖行为。
 */
export const HOME_DROPDOWN_CONTENT_CLASS_NAME =
  'rounded-16 bg-[rgba(23,25,28,0.64)] backdrop-blur-[30px] data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=open]:animate-in';
